import React from "react";
import Flagship from "../../core/flagship";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import { getFormattedValue } from "../../utils/helpers";
import { Card, Icon, Button, Loader } from "semantic-ui-react";
import connect from "react-redux/es/connect/connect";

class AdvisrIoUpload extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getFiles = this.getFiles.bind(this);
    this.getSignedUrl = this.getSignedUrl.bind(this);
    this.uploadError = this.uploadError.bind(this);
    this.missingFiles = this.missingFiles.bind(this);
    this.onViewDownloadFile = this.onViewDownloadFile.bind(this);
    this.handleFinishedUpload = this.handleFinishedUpload.bind(this);
    this.uploadProgress = this.uploadProgress.bind(this);
    this.uploaderChildren = this.uploaderChildren.bind(this);

    this.s3Url = "https://" + Flagship.config.awsBucket + ".s3.amazonaws.com";
    this.state = {
      files: [],
      loading: true,
      uploading: false,
      progress: 0
    };
  }

  componentDidMount() {
    this.getFiles();
  }

  handleFinishedUpload(data) {
    this.setState({
      uploading: false,
      progress: 0
    });

    this.getFiles();
    Flagship.notify("Advisr IO doc uploaded.", "success");
    Flagship.event(
      "advisr-upload",
      data.file.name,
      this.props.recordId,
      this.props.userId
    );
  }

  uploadError(err) {
    Flagship.error(
      "Spreadsheet upload failed. " + err,
      this.props.recordId,
      this.props.userId
    );
  }

  getFiles() {
    let self = this;
    Flagship.get(
      "s3/list",
      {
        bucket: Flagship.config.awsBucket,
        folder: self.props.folder
      },
      function(response) {
        if (response.data.success === true && response.data.files !== null) {
          self.setState(
            {
              files: response.data.files,
              loading: false
            },
            function() {
              self.props.hasAdvisrIo(response.data.files.length !== 0);
            }
          );
        } else if (response.data.files === null) {
          self.setState(
            {
              loading: false
            },
            function() {
              self.props.hasAdvisrIo(false);
            }
          );
        } else {
          Flagship.error(
            "Failed to get IO spreadsheet file.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to get IO spreadsheet file: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  getSignedUrl(file, callback) {
    let self = this;
    Flagship.get(
      "s3/sign",
      {
        bucket: Flagship.config.awsBucket,
        objectName: self.props.folder + "/" + file.name,
        contentType: file.type
      },
      function(data) {
        callback(data.data);
      },
      function(err) {
        if (typeof console.error === "function") {
          console.error(err);
        }
      }
    );
  }

  onViewDownloadFile(file) {
    window.open(
      Flagship.config.apiBase + "file?path=" + encodeURIComponent(file)
    );
  }

  missingFiles() {
    return this.state.loading ? (
      <Loader
        color="blue"
        className="flagship-loader"
        active
        inline="centered"
      />
    ) : (
      <div className="cf no-files-found">No files found.</div>
    );
  }

  uploadProgress(uploader, progress) {
    this.setState({
      uploading: true,
      progress
    });
  }

  uploaderChildren() {
    if (this.state.uploading) {
      return (
        <div className="upload-progress-proposal">
          <div className="uploading-text">
            {typeof this.state.progress === "number"
              ? this.state.progress + "%"
              : this.state.progress}
          </div>
        </div>
      );
    }

    if (this.state.files.length) {
      return (
        <p className="uploader-inner-proposal">
          <Button content={"Upload Another..."} />
        </p>
      );
    }

    return (
      <p className="uploader-inner-proposal">
        <Button content={"Upload Advisr IO"} />
      </p>
    );
  }

  render() {
    let self = this;
    let children = this.uploaderChildren;

    const uploadOptions = {
      server: "http://flagship.dev",
      s3path: this.props.folder,
      getSignedUrl: this.getSignedUrl,
      uploadRequestHeaders: {},
      accept: "application/pdf, application/vnd.ms-*, "
    };

    if (self.state.files.length) {
      return (
        <div>
          {self.state.files.map(function(file, i) {
            return (
              <div className="proposal-file" key={"proposal-" + i}>
                <Card
                  fluid
                  className="single-file"
                  style={{ marginBottom: ".5em" }}
                >
                  <Card.Content>
                    <h3 className="attachment-record-link">
                      <Icon
                        className="feed-icon"
                        disabled
                        size="large"
                        color="grey"
                        name="file text outline"
                      />
                      {file.Key.replace(/^.*[\\\/]/, "")}
                    </h3>
                    <Card.Meta>
                      {getFormattedValue(file.Size, "filesize")}
                    </Card.Meta>
                    <Card.Description>
                      {getFormattedValue(file.LastModified, "time ago")}
                    </Card.Description>
                    <Card.Content extra>
                      <br />
                      <div className="ui file-actions">
                        <Button
                          basic
                          primary
                          onClick={() => {
                            self.onViewDownloadFile(file.Key);
                          }}
                        >
                          View / Download
                        </Button>
                      </div>
                    </Card.Content>
                  </Card.Content>
                </Card>
              </div>
            );
          })}
          {this.props.userRole !== "ae" ? (
            <DropzoneS3Uploader
              onFinish={self.handleFinishedUpload}
              onProgress={self.uploadProgress}
              onError={self.uploadError}
              children={children}
              passChildrenProps={false}
              s3Url={self.s3Url}
              maxSize={1024 * 1024 * 1000}
              upload={uploadOptions}
              className="file-upload-area"
              style={{
                width: "100%",
                height: 100,
                border: "dashed 2px #999",
                borderRadius: 5,
                position: "relative",
                cursor: "pointer",
                overflow: "hidden",
                marginBottom: "2rem"
              }}
            />
          ) : null}
        </div>
      );
    }

    return this.props.userRole !== "ae" ? (
      <div style={{ marginBottom: "2rem" }}>
        <DropzoneS3Uploader
          onFinish={this.handleFinishedUpload}
          onProgress={this.uploadProgress}
          onError={this.uploadError}
          children={children}
          passChildrenProps={false}
          s3Url={this.s3Url}
          maxSize={1024 * 1024 * 100}
          upload={uploadOptions}
          className="file-upload-area"
          style={{
            width: "100%",
            height: 100,
            border: "dashed 2px #999",
            borderRadius: 5,
            position: "relative",
            cursor: "pointer",
            overflow: "hidden"
          }}
        />
      </div>
    ) : (
      <span>You don't have permission to upload files.</span>
    );
  }
}

function mapStateToProps(state) {
  return {
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(AdvisrIoUpload);



// WEBPACK FOOTER //
// ./src/components/misc/AdvisrIoUpload.js